<template>
    <div class="container">
        <b-modal
            :model-value="modEditarCentroCostos"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <label>{{ labels.codigo }}</label>
                        <b-form-input
                            v-model="form.codigo"
                            type="number"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.descripcion }}</label>
                        <b-form-input
                            v-model="form.descripcion"
                            type="text"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.centro_costo }}</label>
                        <b-form-input
                            v-model="form.centro_costo"
                            type="text"
                            class="reset-input"
                        ></b-form-input>
                    </b-form-group>
                    <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                        <b-button
                            class="reset-btn-delete me-auto"
                            @click="eliminaRegistro()"
                        >
                            {{ labels.delete }}
                        </b-button>
                        <b-button
                            class="mr-2 reset-btn-secondary"
                            @click="cierraModal()"
                        >
                            {{ labels.close }}
                        </b-button>
                        <b-button
                            class="reset-btn-primary"
                            @click="guardarCentroCostos()"
                        >
                            {{ labels.save }}
                        </b-button>
                    </div>
                </b-col>                
            </div>
        </b-modal>
        <InacticaItem :InactivaItem="deleteCentroCosto" 
            @confirmDelete="confirmInactivate" 
            @cierraModal="cierraModalDelet"
        >
        </InacticaItem>
    </div>
</template>

<script>
import CentroCostos from '../../../services/CentroCostos'
import InacticaItem from '../../utils/InacticaItem.vue' 
export default {
    name : 'Crear',
    components : {InacticaItem},
    props:{
        modEditarCentroCostos: {
            type: Boolean,
            default: false
        },
        infoCentroCostos: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            form: {
                id: null,
                codigo: "",
                descripcion: "",
                centro_costo: ""
            },
            deleteCentroCosto : false,
            idCentroCosto : null
        }
    },
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Editar centro de costo',
                    save : 'Guardar',
                    close : 'Cerrar',
                    delete: "Eliminar",
                    codigo : 'Código',
                    descripcion : 'Descripción',
                    centro_costo : 'Centro de costo',
                    formInfoTitle: "Datos del centro de costo",
                    formInfoSubtitle: "Actualiza la información del centro de costo y guarda los cambios."
                }
            }else{
                return {
                    title : 'Edit cost center',
                    save : 'Save',
                    close : 'Close',
                    delete: "Delete",
                    codigo : 'Code',
                    descripcion : 'Description',
                    centro_costo : 'Cost center',
                    formInfoTitle: "Cost center data",
                    formInfoSubtitle: "Update the cost center information and save the changes."
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        guardarCentroCostos(){

            if (!this.form.codigo || !this.form.descripcion.trim() || !this.form.centro_costo.trim()) {
                this.$toast.error("Campo(s) pendiente(s) por diligenciar");
                return;
            }

            const info = {
                'id' : this.form.id,
                'codigo' : this.form.codigo, 
                'descripcion' : this.form.descripcion, 
                'centro_costo' : this.form.centro_costo, 
                'idUser' : this.$store.state.userId 
            }
            // console.log(info);

            CentroCostos.updateCentroCostosById(info)
            .then((res) => { 
                if(res.status == 200){ 
                    this.$toast.success(res.data.message) 
                    this.$emit("actualizado");
                    this.cierraModal();
                }
            })
            .catch((err) => { 
                if(err.response.status == 409){ 
                    this.$toast.error(err.response.data.message) 
                }else{
                    this.$toast.error("Algo pasó, intentalo de nuevo") 
                }
            })            
        },
        cierraModalDelet() {
            this.deleteCentroCosto = false;
        },
        eliminaRegistro() {
            this.idCentroCosto = this.form.id;
            this.deleteCentroCosto = true;
        },
        confirmInactivate() {

            CentroCostos.deleteCentroCostos(this.idCentroCosto) 
            .then((res) => { 
                if(res.status == 200){ 
                    this.$toast.success(res.data.message) 
                    this.$emit("eliminado");
                    this.cierraModalDelet();
                    this.cierraModal();
                }
            })
            .catch((error) => error) 
        }
    },
    watch: {
        infoCentroCostos: {
            immediate: true,
            deep: true,
            handler(value) {
                if (value) {
                    this.form = { ...value };
                }
            }
        }
    },
}
</script>

<style>

</style>
